// Page addresses: "/" (workspaces), "/w/:id/:tab" (a workspace), "/w/:id/clusters/:cluster" (one cluster), "/join/:code" (an invite link).
// Links with data-link change the page without reloading.

/** @typedef {{ name: "home" } | { name: "settings" } | { name: "workspace", id: string, tab: string, sub?: string } | { name: "join", code: string }} Route */

/** @returns {Route} */
export function currentRoute() {
  const path = location.pathname;
  if (path === "/settings" || path === "/settings/") return { name: "settings" };
  let m;
  if ((m = path.match(/^\/workspace\/([a-z0-9-]+)(?:\/(team|clusters|docs)(?:\/([a-z0-9]+))?)?\/?$/))) return { name: "workspace", id: m[1], tab: m[2] || "team", sub: m[3] };
  if ((m = path.match(/^\/w\/([a-z0-9]+)\/(clusters|docs)\/([a-z0-9]+)\/?$/))) return { name: "workspace", id: m[1], tab: m[2], sub: m[3] };
  if ((m = path.match(/^\/w\/([a-z0-9]+)(?:\/(team|clusters|docs))?\/?$/))) return { name: "workspace", id: m[1], tab: m[2] || "team" };
  if ((m = path.match(/^\/join\/([A-Za-z0-9-]+)\/?$/))) return { name: "join", code: m[1] };
  return { name: "home" };
}

let onChange = () => {};
let mayLeave = () => true;
let position = 0, reverting = false;

/** A page can protect an unsaved editor. The returned cleanup removes only its own guard.
 * @param {() => boolean} check */
export function guardNavigation(check) {
  mayLeave = check;
  return () => { if (mayLeave === check) mayLeave = () => true; };
}

/** @param {() => void} fn */
export function listen(fn) {
  onChange = fn;
  position = history.state?.wsPosition ?? 0;
  history.replaceState({ ...history.state, wsPosition: position }, "");
  addEventListener("popstate", () => {
    if (reverting) { reverting = false; return; }
    const next = history.state?.wsPosition ?? position - 1;
    if (!mayLeave()) {
      reverting = true;
      history.go(position - next);
      return;
    }
    position = next;
    onChange();
  });
  document.addEventListener("click", (e) => {
    const a = /** @type {HTMLElement} */ (e.target).closest?.("a[data-link]");
    if (!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    e.preventDefault();
    go(a.getAttribute("href"));
  });
}

/** @param {string} path @param {{ replace?: boolean }} [o] */
export function go(path, o = {}) {
  if (!mayLeave()) return;
  if (path !== location.pathname + location.search) {
    if (!o.replace) position++;
    history[o.replace ? "replaceState" : "pushState"]({ wsPosition: position }, "", path);
  }
  onChange();
}

const workspaceSlugs = new Map();
export function registerWorkspaces(list) { for (const w of list) workspaceSlugs.set(w.id, w.slug || w.id); }
export function workspacePath(id, suffix = '') {
  return `/workspace/${workspaceSlugs.get(id) || id}${suffix === '/team' ? '' : suffix}`;
}
